import { render, staticRenderFns } from "./TwoColumnDetail.vue?vue&type=template&id=e7ada99a"
import script from "./TwoColumnDetail.vue?vue&type=script&lang=js"
export * from "./TwoColumnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports